export default "/images/vendor/flag-icon-css/flags/4x3/ls.svg?1656b1dc3d7ad3685ca49742447a3326";